import gql from 'graphql-tag';

export const cardSideCreate = gql`
  mutation cardSideCreate($input: CardSideCreateInput!) {
    cardSideCreate(input: $input) {
      card_side {
        id
      }
    }
  }
`;

export const cardSideUpdate = gql`
  mutation cardSideUpdate($input: CardSideUpdateInput!) {
    cardSideUpdate(input: $input) {
      card_side {
        id
      }
    }
  }
`;

export const cardSidesDelete = gql`
  mutation cardSidesDelete($input: CardSidesDeleteInput!) {
    cardSidesDelete(input: $input) {
      success
    }
  }
`;
